import { BoolFilter } from "gen/search/service/service_pb"
import { useMemo } from "react"

import { UseBoolFilterProps, UseBoolFilterRes } from "./types/useFilter.types"

export function useBoolFilter(props: UseBoolFilterProps): UseBoolFilterRes {
  const { useFilter, ...restProps } = props

  const { selectedKeys, ...res } = useFilter({
    ...restProps,
    values: [BoolFilter.TRUE, BoolFilter.FALSE],
    keyExtractor: (option) => option.toString(),
    autoFilterOptions: true,
  })

  const selectedValue = useMemo(
    () =>
      selectedKeys.length === 1 ? Number(selectedKeys[0]) : BoolFilter.NONE,
    [selectedKeys]
  )

  const selectedBools = useMemo(
    (): BoolFilter[] => selectedKeys.map((v) => Number(v)),
    [selectedKeys]
  )

  return {
    ...res,
    selectedValue,
    selectedBools,
  }
}
